module.exports = __webpack_public_path__ + "media/images/application2/AppBookingsTalk__bottom__buttons__a-f495bdbfd0b10bb7521596d55de9d822.svg";